import { useState } from "react";
import { useQuery } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";

export const useComments = ({ space }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isLoading, refetch } = useQuery(
    internalApi.courses.listComments({
      courseId: space?.id,
      params: {
        page: currentPage,
      },
    }),
    {
      enabled: !!space?.id,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );
  const records = data?.records || [];
  const { page, per_page: perPage, count: totalCount } = data || {};

  const loadPage = newPage => {
    setCurrentPage(newPage);
  };

  return { records, isLoading, totalCount, page, perPage, loadPage, refetch };
};
